export const localUsers = {
    addUser: (userData) => {
        let users = {};
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            users = JSON.parse(dbUsers);
        }
        users[userData.id] = userData;
        localdb.put("user_map", JSON.stringify(users));
    },
    getAllUsers: () => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            return JSON.parse(dbUsers);
        }
    },
    getUser: (userId) => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            return JSON.parse(dbUsers)[userId];
        }
    },
    deleteUser: (userId) => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            let users = JSON.parse(dbUsers);
            delete users[userId];
            localdb.put("user_map", JSON.stringify(users));
        }
    },
    setActiveUser: (userData) => {
        localdb.put("activeUser", JSON.stringify(userData));
    },
    getActiveUser: () => {
        return JSON.parse(localdb.get("activeUser"));
    },
    clearActiveUser: () => {
        localdb.remove("activeUser");
    },

}


export const localdb = {
    put: (k, v) => {
        localStorage.setItem(buildKey(k), v)
    },
    get: (k) => {
        return localStorage.getItem(buildKey(k));
    },
    remove: (k) => {
        localStorage.removeItem(buildKey(k));
    }
}

const quiz_pin_name = "quiz_pin";
export const quizLocaldb = {
    getOrDefault: (k) => {
        let item = localdb.get(k);
        if (!item) {
            localdb.put(k, JSON.stringify({}));
            item = localdb.get(k);
        }
        return JSON.parse(item);
    },
    get: (pin) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        if (quizData) {
            return quizData[pin];
        }
    },
    put: (pin, participantObj) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        if (pin && participantObj.participantId && quizData) {
            let pinData = quizData[pin];
            if (!pinData) {
                quizData[pin] = {};
            }
            participantObj.addedOn = Date.now();
            quizData[pin][participantObj.participantId] = participantObj;
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },

    cleanUpParticipants: async (pin) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        /*delete quizData[pin];
        localdb.put(quiz_pin_name, JSON.stringify(quizData));*/

        if (quizData && pin && quizData[pin]) {
            const quizParticipants = quizData[pin];
            let filteredParticipants = {};
            Object.keys(quizParticipants).forEach((key, index) => {
                const participant = quizParticipants[key];
                if (participant.addedOn && Date.now() - participant.addedOn <= 86400000) {
                    filteredParticipants[key] = participant;
                }
            })

            if (filteredParticipants && Object.keys(filteredParticipants).length > 0) {
                quizData[pin] = filteredParticipants;
            } else {
                delete quizData[pin];
            }
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },

    remove: (pin, participantId) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        const pinData = quizData && quizData[pin];
        if (pin && participantId && pinData) {
            delete quizData[pin][participantId];
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },
    removeAll: (pin) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        const pinData = quizData && quizData[pin];
        if (pin && pinData) {
            delete quizData[pin];
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    }
}

const buildKey = (key) => {
    let prefix = "QZ_";
    if (process.env.NODE_ENV === "development") {
        prefix += "DEV_"
    }
    return prefix + key;
}